import { render, staticRenderFns } from "./ReportProductivity.vue?vue&type=template&id=450fdb02&scoped=true&"
import script from "./ReportProductivity.vue?vue&type=script&lang=js&"
export * from "./ReportProductivity.vue?vue&type=script&lang=js&"
import style0 from "./ReportProductivity.vue?vue&type=style&index=0&id=450fdb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450fdb02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
